import gql from 'graphql-tag';

export const GET_FILTERS_OPTIONS = gql`
  query FiltersOptions($input: VOFiltersOptionsInput!) {
    voFiltersOptions(input: $input) {
      error
      success
      list {
        group
        list {
          label
          value
        }
      }
    }
  }
`;
